import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

const MEDIA_COMPONENT_CLASS = 'media-component';
const VIDEO_BUTTON_CLASS = 'video-button';
const VIDEO_DESKTOP_THUMBNAIL_CLASS = 'desktop-thumbnail';
const VIDEO_MOBILE_THUMBNAIL_CLASS = 'mobile-thumbnail';
const HIGH_Z_CLASS = 'z-[5]';
const LOW_Z_CLASS = 'z-[1]';

class Media {
    constructor() {
        this._media = document.querySelectorAll(`.${MEDIA_COMPONENT_CLASS}`);

        this._media && this._run();
    }
    _run() {
        this._media.forEach((item) => {
            const button = item.querySelector(`.${VIDEO_BUTTON_CLASS}`);
            const desktopThumbnail = item.querySelector(`.${VIDEO_DESKTOP_THUMBNAIL_CLASS}`);
            const mobileThumbnail = item.querySelector(`.${VIDEO_MOBILE_THUMBNAIL_CLASS}`);
            const video = item.querySelector('video');
            this._isPlaying = false;

            if (button && video) {
                button.addEventListener('click', () => {
                    video.play();
                    this._hideButton(video, button);
                    this._hideThumbnail(desktopThumbnail, mobileThumbnail);
                });

                video.addEventListener('ended', () => {
                    document.exitFullscreen();
                    this._showButton(video, button);
                    this._showThumbnail(desktopThumbnail, mobileThumbnail);
                });
                video.addEventListener('play', () => {
                    this._isPlaying = true;
                    this._hideButton(video, button);
                });
                video.addEventListener('seeking', () => {
                    this._isPlaying = true;
                });
                video.addEventListener('pause', () => {
                    this._isPlaying = false;
                    this._showButton(video, button);
                });
            }
        });
    }
    _hideButton(video, button) {
        this._isPlaying = true;
        video.controls = true;
        button.classList.add('opacity-0');
        button.classList.add('pointer-events-none');
    }
    _showButton(video, button) {
        setTimeout(() => {
            if (!this._isPlaying) {
                video.controls = false;
                button.classList.remove('opacity-0');
                button.classList.remove('pointer-events-none');
            }
            this._isPlaying = false;
        }, 100);
    }
    _hideThumbnail(desktopThumbnail, mobileThumbnail) {
        if (desktopThumbnail) {
            desktopThumbnail.classList.remove(HIGH_Z_CLASS);
            desktopThumbnail.classList.add(LOW_Z_CLASS);
        }
        if (mobileThumbnail) {
            mobileThumbnail.classList.remove(HIGH_Z_CLASS);
            mobileThumbnail.classList.add(LOW_Z_CLASS);
        }
    }
    _showThumbnail(desktopThumbnail, mobileThumbnail) {
        if (desktopThumbnail) {
            desktopThumbnail.classList.add(HIGH_Z_CLASS);
            desktopThumbnail.classList.remove(LOW_Z_CLASS);
        }
        if (mobileThumbnail) {
            mobileThumbnail.classList.add(HIGH_Z_CLASS);
            mobileThumbnail.classList.remove(LOW_Z_CLASS);
        }
    }
}

const media = new Media();
